import {ImpersonateServices} from "./impersonate.services";
import {impersonateTypes} from "./impersonate.types";

export const getAllImpersonateUsers = () => {
    return (dispatch, getState) => {
        ImpersonateServices.getImpersonateUsers().then(response => {
            dispatch({
                type: impersonateTypes.GET_ALL_IMPERSONATE_USERS,
                payload: response != null && response.userImpersonates ? response.userImpersonates : []
            })
        })
    }
}
